@if (name()) {
  <span class="content__transport-name ci-paragraph-p1-semibold">
    {{ name() | translate }}
  </span>
}